import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import LandingSectionHeader from "./LandingSectionHeader";
import { LANDING_COMPARISON } from "../content/landing";
import "./LandingComparisonSection.css";

export default function LandingComparisonSection() {
  const { title, subtitle, columns, rows } = LANDING_COMPARISON;

  return (
    <section
      id="comparison"
      className="landing-band landing-band--comparison landing-section landing-section--comparison"
    >
      <div className="landing-container">
        <LandingSectionHeader label="05 · Сравнение" title={title} desc={subtitle} />
        <div className="landing-band__panel landing-band__panel--comparison">
          <div className="landing-comparison-table-wrap">
            <table className="landing-comparison-table">
              <thead>
                <tr>
                  <th scope="col">Критерий</th>
                  {columns.map(({ id, label, highlight }) => (
                    <th
                      key={id}
                      scope="col"
                      className={highlight ? "landing-comparison-table__highlight" : ""}
                    >
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map(({ label, values }) => (
                  <tr key={label}>
                    <th scope="row">{label}</th>
                    {values.map((value, index) => (
                      <td
                        key={columns[index].id}
                        className={
                          columns[index].highlight
                            ? "landing-comparison-table__highlight"
                            : ""
                        }
                      >
                        <span className="landing-comparison-table__cell">
                          {index === 0 ? (
                            <CheckCircleOutlineIcon
                              className="landing-comparison-table__icon landing-comparison-table__icon--yes"
                              fontSize="small"
                            />
                          ) : (
                            <RemoveCircleOutlineIcon
                              className="landing-comparison-table__icon landing-comparison-table__icon--no"
                              fontSize="small"
                            />
                          )}
                          {value}
                        </span>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
